module.exports = __webpack_public_path__ + "left.1FYE4LAY.svg";